export const ru = {
    adaptive: 'Адаптивный',
    all: 'Все',
    'banner-sizes': 'Размеры баннеров',
    categories: 'Категории',
    formats: 'Форматы',
    operators: 'Операторы',
    'predictor-detailed-less': '< {sum}',
    'predictor-error': 'Прогноз временно недоступен',
    'predictor-sum-from': 'из {sum}',
    'predictor-sum-less': 'из < {sum}',
    regions: 'Регионы',
    screens: 'Экраны',
    zones: 'Зоны'
};
